"use client";
import { useState, useEffect } from "react";
import { initialState } from "store/reducers/config/fetchConfig";
import styles from "./JobClient.pc.module.scss";
import { useSharedData } from "bossjob-remote/dist/hooks";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton
} from "react-share";
import { fetchUserShare } from "store/services/users/share";
// import { FacebookIcon, LinkedinIcon, TwitterIcon, CopyIcon } from 'images'
import Toast from "app/components/Toast";

export type sharePropsType = {
  text: string;
  jobId: number;
  jobUrl: string;
  company: {
    [key: string]: any;
  };
  recruiter: {
    [key: string]: any;
  };
};

const JobClient = (props: sharePropsType) => {
  const [isOnSharedButtion, setIsOnSharedButton] = useState(false);
  const [isOnSharedPop, setIsOnSharedPop] = useState(false);
  const showSharePop = isOnSharedButtion || isOnSharedPop;
  const { jobDetail, accountSetting } = useSharedData("DICTIONARY") ?? {
    jobDetail: { header: {} }
  };
  const shareModal = jobDetail?.shareModal ?? {};

  const [reportJobReasonList, setReportJobReasonList] = useState<Array<any>>(null);
  const config = useSharedData("CONFIG") ?? initialState.response;
  useEffect(() => {
    setReportJobReasonList(config?.report_job_reasons ?? initialState.response.report_job_reasons);
  }, [config]);

  const meInfo = useSharedData("ME");

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link);
    setTimeout(() => {
      Toast.success("Link copied success!");
    }, 500);
  };
  const tokenData = () => {
    if (!meInfo?.id) {
      return;
    }
    const data = {
      jobseeker_id: meInfo?.id,
      recruiter_id: props.recruiter?.id,
      company_id: props.company?.id,
      job_id: props.jobId
    };

    fetchUserShare(data)
      .then(({ status }: any) => {
        if (status === 200) {
          //
        }
      })
      .catch(() => {
        //
      });
  };
  return (
    <>
      {/* {reportJobReasonList?.length ? ( */}
      <div
        // onClick={() => setIsShowSearch(true)}
        className={styles.sharedWrap}
        onMouseEnter={() => {
          setIsOnSharedButton(true);
        }}
        onMouseLeave={() => {
          setTimeout(() => {
            setIsOnSharedButton(false);
          }, 200);
        }}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='17'
          height='14'
          viewBox='0 0 17 14'
          fill='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.8327 0.776732C16.0593 0.495332 17.0994 1.70358 16.6386 2.87468L13.0388 12.0241C12.5726 13.2092 11.1161 13.6397 10.0805 12.8985L7.76388 11.2405C6.64338 10.4386 6.45687 8.85602 7.33736 7.81671L5.67972 8.50799C4.96798 8.8048 4.15585 8.73304 3.50718 8.31604L0.96932 6.68456C-0.196024 5.93541 0.115279 4.15308 1.46557 3.8433L14.8327 0.776732ZM15.1825 2.30181L1.81544 5.36838L4.35329 6.99986C4.56952 7.13886 4.85927 7.11786 5.07747 7.06384C5.29568 7.00981 6.30172 6.67779 7.72583 6.24995C9.14994 5.8221 10.0973 6.36608 9.40054 7.45403C8.70376 8.54198 8.55706 8.79904 8.55706 8.79904C8.30036 9.23264 8.29087 9.69357 8.67452 9.96814L10.9911 11.6261C11.1982 11.7743 11.4895 11.6882 11.5828 11.4512L15.1825 2.30181Z'
            fill='black'
          />
        </svg>
        {props.text}
        <div
          className={styles.shareMenu}
          style={{
            display: showSharePop ? "flex" : "none"
          }}
          onMouseEnter={() => {
            setIsOnSharedPop(true);
          }}
          onMouseLeave={() => {
            setIsOnSharedPop(false);
          }}
        >
          <div className={styles.shareItem}>
            <div
              onClick={() => handleCopyLink(`${globalThis?.location?.origin}${props?.jobUrl}`)}
              className={styles.copyLink}
            >
              <CopyLinkIcon />
              <span className={styles.shareText}>{shareModal.linkCopied}</span>
            </div>
          </div>
          <div className={styles.shareItem} onClick={tokenData}>
            <FacebookShareButton
              url={`${globalThis?.location?.origin}${props?.jobUrl}`}
              className={styles.ModalShareItemLink}
            >
              <FacebookIcon />
              <span className={styles.shareText}>{shareModal.facebook}</span>
            </FacebookShareButton>
          </div>
          <div className={styles.shareItem} onClick={tokenData}>
            <TwitterShareButton
              url={`${globalThis?.location?.origin}${props?.jobUrl}`}
              className={styles.ModalShareItemLink}
            >
              <TwitterIcon />
              <span className={styles.shareText}>{shareModal.twitter}</span>
            </TwitterShareButton>
          </div>
          <div className={styles.shareItem} onClick={tokenData}>
            <LinkedinShareButton
              url={`${globalThis?.location?.origin}${props?.jobUrl}`}
              className={styles.ModalShareItemLink}
            >
              <LinkedinIcon />
              <span className={styles.shareText}>{shareModal.linkedin}</span>
            </LinkedinShareButton>
          </div>

          <div className={styles.shareItem} onClick={tokenData}>
            <WhatsappShareButton
              url={`${globalThis?.location?.origin}${props?.jobUrl}`}
              className={styles.ModalShareItemLink}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 50 50'
                fill='none'
              >
                <g clipPath='url(#clip0_3544_881)'>
                  <path
                    d='M25 50C11.195 50 0 38.805 0 25C0 11.195 11.195 0 25 0C38.805 0 50 11.195 50 25C50 38.805 38.805 50 25 50Z'
                    fill='#25D366'
                  />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M36.695 13.36C33.595 10.255 29.465 8.54504 25.07 8.54004C16.015 8.54004 8.64 15.91 8.64 24.97C8.64 27.865 9.395 30.695 10.835 33.185L8.505 41.7L17.215 39.415C19.615 40.725 22.315 41.415 25.065 41.415H25.07C34.125 41.415 41.495 34.045 41.5 24.985C41.505 20.595 39.8 16.465 36.695 13.36ZM25.075 38.64H25.07C22.62 38.64 20.215 37.98 18.12 36.735L17.62 36.44L12.45 37.795L13.83 32.755L13.505 32.24C12.14 30.065 11.415 27.555 11.415 24.97C11.42 17.44 17.545 11.315 25.08 11.315C28.73 11.315 32.155 12.74 34.735 15.32C37.315 17.9 38.735 21.335 38.73 24.98C38.73 32.515 32.6 38.64 25.075 38.64ZM32.565 28.41C32.155 28.205 30.135 27.21 29.76 27.075C29.385 26.94 29.11 26.87 28.835 27.28C28.56 27.69 27.775 28.615 27.535 28.89C27.295 29.165 27.055 29.2 26.645 28.995C26.235 28.79 24.91 28.355 23.345 26.955C22.125 25.865 21.3 24.52 21.06 24.11C20.82 23.7 21.035 23.475 21.24 23.27C21.425 23.085 21.65 22.79 21.855 22.55C22.06 22.31 22.13 22.14 22.265 21.865C22.4 21.59 22.335 21.35 22.23 21.145C22.125 20.94 21.305 18.92 20.965 18.095C20.63 17.295 20.295 17.405 20.04 17.39C19.8 17.38 19.525 17.375 19.255 17.375C18.98 17.375 18.535 17.48 18.16 17.89C17.785 18.3 16.725 19.295 16.725 21.315C16.725 23.335 18.195 25.29 18.4 25.56C18.605 25.835 21.295 29.98 25.415 31.76C26.395 32.185 27.16 32.435 27.755 32.625C28.74 32.94 29.635 32.895 30.34 32.79C31.13 32.67 32.77 31.795 33.11 30.84C33.45 29.88 33.45 29.06 33.35 28.89C33.25 28.72 32.975 28.62 32.565 28.41Z'
                    fill='white'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_3544_881'>
                    <rect width='50' height='50' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              <span className={styles.shareText}>{shareModal.whatsapp}</span>
            </WhatsappShareButton>
          </div>
          <div className={styles.shareItem} onClick={tokenData}>
            <EmailShareButton
              url={`${globalThis?.location?.origin}${props?.jobUrl}`}
              className={styles.ModalShareItemLink}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 50 50'
                fill='none'
              >
                <g clipPath='url(#clip0_3544_894)'>
                  <path
                    d='M0 25C0 38.7851 11.2149 50 25 50C38.7851 50 50 38.7851 50 25C50 11.2149 38.7851 0 25 0C11.2149 0 0 11.2149 0 25Z'
                    fill='white'
                  />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M25 50C11.2149 50 0 38.7851 0 25C0 11.2149 11.2149 0 25 0C38.7851 0 50 11.2149 50 25C50 38.7851 38.7851 50 25 50ZM37.9646 33.7823C38.2729 33.7823 38.5237 33.5315 38.5237 33.2232V17.5282L25.804 27.629C25.5687 27.816 25.2842 27.9095 24.9999 27.9095C24.7156 27.9095 24.4312 27.8159 24.1958 27.629L11.4762 17.5282V33.2232C11.4762 33.5315 11.7271 33.7823 12.0353 33.7823H37.9646ZM36.0154 16.2177L25 24.9652L13.9845 16.2177H36.0154ZM41.11 16.7768V33.2234C41.11 34.9577 39.6989 36.3687 37.9646 36.3687H12.0353C10.3009 36.3687 8.89004 34.9577 8.89004 33.2234V16.7768C8.89004 15.0425 10.301 13.6315 12.0353 13.6315H37.9646C39.6989 13.6314 41.11 15.0425 41.11 16.7768Z'
                    fill='#BCBCBC'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_3544_894'>
                    <rect width='50' height='50' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              <span className={styles.shareText}>{accountSetting?.email}</span>
            </EmailShareButton>
          </div>
        </div>
      </div>
      {/* ) : null} */}
    </>
  );
};

const CopyLinkIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none'>
    <path
      d='M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10Z'
      fill='#121212'
    />
    <path
      d='M9.60491 8.3396L11.2254 6.71914C11.822 6.12251 12.7694 6.10258 13.3415 6.67464C13.9135 7.24671 13.8936 8.1941 13.297 8.79075L11.6765 10.4112'
      stroke='white'
      strokeWidth='0.833333'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
    <path
      d='M8.35027 9.59814L6.72981 11.2186C6.13319 11.8152 6.0559 12.7341 6.68531 13.3347C7.31473 13.9353 8.20479 13.8868 8.80142 13.2902L10.4219 11.6697'
      stroke='white'
      strokeWidth='0.833333'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
    <path
      d='M10.5765 9.3908L11.3867 8.58057'
      stroke='white'
      strokeWidth='0.833333'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
    <path
      d='M8.68586 11.2814L9.49609 10.4712'
      stroke='white'
      strokeWidth='0.833333'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
  </svg>
);

const FacebookIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none'>
    <path
      d='M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10Z'
      fill='#1977F3'
    />
    <path
      d='M15 10C15 7.25 12.75 5 10 5C7.25 5 5 7.25 5 10C5 12.5 6.8125 14.5625 9.1875 14.9375V11.4375H7.9375V10H9.1875V8.875C9.1875 7.625 9.9375 6.9375 11.0625 6.9375C11.625 6.9375 12.1875 7.0625 12.1875 7.0625V8.3125H11.5625C10.9375 8.3125 10.75 8.6875 10.75 9.0625V10H12.125L11.875 11.4375H10.6875V15C13.1875 14.625 15 12.5 15 10Z'
      fill='white'
    />
  </svg>
);
const TwitterIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none'>
    <path
      d='M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10Z'
      fill='black'
    />
    <path
      d='M5.65518 5.9375H8.44289L10.4225 8.64914L12.8248 5.9375H13.7028L10.819 9.192L14.375 14.0625H11.588L9.29073 10.9164L6.50302 14.0625H5.625L8.89425 10.3736L5.65518 5.9375ZM6.99965 6.61458L11.9543 13.3854H13.0305L8.07591 6.61458H6.99965Z'
      fill='white'
    />
  </svg>
);

const LinkedinIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none'>
    <path
      d='M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10Z'
      fill='#0B66C1'
    />
    <path
      d='M7.25 15H5.125V8.3125H7.25V15ZM6.1875 7.375C5.5 7.375 5 6.875 5 6.1875C5 5.5 5.5625 5 6.1875 5C6.875 5 7.375 5.5 7.375 6.1875C7.375 6.875 6.875 7.375 6.1875 7.375ZM15 15H12.875V11.375C12.875 10.3125 12.4375 10 11.8125 10C11.1875 10 10.5625 10.5 10.5625 11.4375V15H8.4375V8.3125H10.4375V9.25C10.625 8.8125 11.375 8.125 12.4375 8.125C13.625 8.125 14.875 8.8125 14.875 10.875V15H15Z'
      fill='white'
    />
  </svg>
);

export default JobClient;
